import { createFileRoute } from "@tanstack/react-router";

import { ExportPage } from "../../../features/reports/export-page";

export const Route = createFileRoute("/_app/reports/exports/$id")({ component: ExportRoute });

function ExportRoute() {
  const { id } = Route.useParams();
  return <ExportPage id={id} />;
}
